import { FC } from "react";
import { MetricWidgetBase } from "@app/network-portfolio-management/components/widgets/MetricWidgetBase";

interface Props {
  projectIds: number[] | undefined;
}

export const ProjectCountWidget: FC<Props> = ({ projectIds }) => {
  return (
    <MetricWidgetBase title="Projects">
      <div className="main-metric">
        {projectIds?.length ?? 0}
      </div>
    </MetricWidgetBase>
  );
};
